import React from 'react';
import { X, Menu } from 'lucide-react';

const Navbar = ({ scrolled, mobileMenuOpen, setMobileMenuOpen }) => {
  const handleNavLinkClick = () => setMobileMenuOpen(false);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <a href="/">
            <span className="logo-arrow">Arrow</span>
            <span className="logo-ai">.AI</span>
          </a>
        </div>
        
        <div className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <ul className="navbar-links">
            <li><a href="#demo" onClick={handleNavLinkClick}>Demo</a></li>
            <li><a href="#features" onClick={handleNavLinkClick}>Features</a></li>
            <li><a href="#pricing" onClick={handleNavLinkClick}>Pricing</a></li>
            <li><a href="#models" onClick={handleNavLinkClick}>Models</a></li>
            <li><a href="#faq" onClick={handleNavLinkClick}>FAQ</a></li>
          </ul>
          
          <div className="navbar-buttons">
            <a href="/login" className="login-button" onClick={handleNavLinkClick}>Log in</a>
            <a href="/signup" className="signup-button" onClick={handleNavLinkClick}>Sign up</a>
          </div>
        </div>
        
        <button 
          className="mobile-menu-toggle" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
